module.exports = __webpack_public_path__ + "img/eghtesad-novin.6363694d.png";